import { render, staticRenderFns } from "./v-field-edit-select.vue?vue&type=template&id=535b6a0a&"
import script from "./v-field-edit-select.vue?vue&type=script&lang=js&"
export * from "./v-field-edit-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports